import { Service } from './service.model';
import { Role } from './role.model';
import { OrgModel } from './org.model';
import { CreateUser } from './create-user.model';

export interface UserCSVImport {
  avs: string;
  officialFirstName: string;
  officialLastName: string;
  dateOfBirth: string;
  gender: string;
  firstName: string;
  lastName: string;
  address: string;
  zip: string;
  locality: string;
  preferredLanguage: string;
  email: string;
  phone: string;
  activationCode: string;
  twoFactorAuthType: string;
  groupEtablissementList: string;
  classe: string;
  canton: string;
  password: string;
  title: string;
  rolesList: string;
  organisationList: string;

  //Not part of the template
  roles: Role[];
  organisation: string[];
  groupEtablissement: string[];
}

export class UserInfo {
  id: string;
  oid: string;
  avs: string;
  officialFirstName: string;
  officialLastName: string;
  dateOfBirth: string;
  gender: string;
  firstName: string;
  lastName: string;
  address: string;
  zip: string;
  locality: string;
  preferredLanguage: string;
  email: string;
  officialemail: string;
  phone: string;
  username: string;
  token: string;
  canChangeName: boolean;
  canChangeNameStd: boolean;
  mustChangePwd: boolean;
  twoFactorAuthType: string;
  lifeCycleState: string;
  services: Service[];
  roles: Role[];
  groupEtablissement: string[];
  orgs: OrgModel[];
  organisation: string[];
  classe: string;
  samAccountName: string;
  //Added fields
  hasProfilePicture: boolean;
  sdegre: string;
  sfiliere: string;
  avsAlign: boolean;
  comments: string;
  misalignedFirstname: string;
  misalignedName: string;
}

export function toCreateUserModel(input: UserCSVImport): CreateUser {
  return {
    firstName: input.firstName,
    lastName: input.lastName,
    email: input.email,
    locality: input.locality,
    password: input.password,
    title: input.title,
    preferredLanguage: input.preferredLanguage,
    extension: {
      activationCode: input.activationCode,
      address: input.address,
      avs: input.avs,
      canton: input.canton,
      class: input.classe,
      dateOfBirth: input.dateOfBirth,
      establishmentNames: [input.groupEtablissementList],
      gender: input.gender,
      officialFirstName: input.officialFirstName,
      officialLastName: input.officialLastName,
      orgNames: [input.organisationList],
      phone: input.phone,
      twoFactorAuthType: input.twoFactorAuthType,
      zip: input.zip,
    },
    orgAssignments: [{ name: input.rolesList }],
  };
}
